import { createContext } from 'react';

export type TransactionsCtx = {
  transactionsSearchStatus: boolean | null;
  transactionsSearchError: string;
  transactionRefundError: string;
  showTransactionsSearchErrorAlert: boolean;
  showTransactionsRefundErrorAlert: boolean;
  showTransactionsRefundSuccessAlert: boolean;
};

const TransactionsContext = createContext<TransactionsCtx>({
  transactionsSearchStatus: false,
  transactionsSearchError: '',
  transactionRefundError: '',
  showTransactionsSearchErrorAlert: false,
  showTransactionsRefundErrorAlert: false,
  showTransactionsRefundSuccessAlert: false,
});

export default TransactionsContext;
